<template>
  <div id="soldout-flip-grid">
    <v-toolbar
      flat
    >
      <v-toolbar-title class="text-h6 text-md-h5 pa-0">Funded / Awaiting Sale</v-toolbar-title>
    </v-toolbar>
    <v-row v-if="flipSoldOutAssetList">
      <v-col
        v-for="(asset, a) in flipSoldOutAssetList.entries"
        :key="a"
        cols="12"
        md="3"
        sm="6"
        class="align-self-stretch"
      >
        <CarCard :asset="asset"></CarCard>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import CarCard from '../components/CarCard.vue'
  import {mapGetters, mapActions } from 'vuex'

  export default {
    name: 'ActiveFlipGridSoldOut',

    components: {
      CarCard
    },

    computed: {
      ...mapGetters(['flipSoldOutAssetList'])
    },

    data: () => ({
    }),

    methods: {
      ...mapActions(['getSoldOutFlipAssets']),
    },

    created() {
      this.getSoldOutFlipAssets()
    }
  }
</script>
